import Filter from '@/components/Filter';
import { CURRENT_SCHOOL_YEAR, SCHOOL_YEARS } from 'constants/schoolYears';

// TODO use url params to add/remove (also dont include if its currentYear)
export default function SchoolYearFilter({ value }: { value?: string | null }) {
  return <Filter pathExtractor={schoolYear => `?season=${schoolYear}`} value={value || CURRENT_SCHOOL_YEAR} options={SCHOOL_YEARS} />;
}
